import { render, staticRenderFns } from "./toupiao.vue?vue&type=template&id=b6e20018&scoped=true&"
import script from "./toupiao.vue?vue&type=script&lang=js&"
export * from "./toupiao.vue?vue&type=script&lang=js&"
import style0 from "./toupiao.vue?vue&type=style&index=0&id=b6e20018&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e20018",
  null
  
)

export default component.exports